/**
 * Currency catalogue shared by every user-facing foreign-gift and holiday-spend
 * flow. GBP and USD are the only family ledger currencies; the remaining codes
 * are transaction-only reference currencies.
 *
 * The daily server refresh keeps one GBP quote for every code except GBP. A
 * contract test in `supabase/functions/refresh-fx-rates/index.test.ts` prevents
 * the server and app catalogues from drifting apart.
 */
export const SUPPORTED_MONEY_CURRENCIES = [
  { code: 'GBP', label: 'British pounds (£)' },
  { code: 'USD', label: 'US dollars ($)' },
  { code: 'EUR', label: 'Euros (€)' },
  { code: 'CAD', label: 'Canadian dollars (C$)' },
  { code: 'AUD', label: 'Australian dollars (A$)' },
  { code: 'CHF', label: 'Swiss francs (CHF)' },
  { code: 'DKK', label: 'Danish kroner (DKK)' },
  { code: 'NOK', label: 'Norwegian kroner (NOK)' },
  { code: 'SEK', label: 'Swedish kronor (SEK)' },
  { code: 'PLN', label: 'Polish zloty (PLN)' },
  { code: 'CZK', label: 'Czech koruna (CZK)' },
  { code: 'HUF', label: 'Hungarian forints (HUF)' },
  { code: 'RON', label: 'Romanian lei (RON)' },
  { code: 'NZD', label: 'New Zealand dollars (NZ$)' },
  { code: 'ZAR', label: 'South African rand (R)' },
] as const;

export const DAILY_GBP_QUOTE_CURRENCY_CODES = [
  'AUD',
  'CAD',
  'CHF',
  'CZK',
  'DKK',
  'EUR',
  'HUF',
  'NOK',
  'NZD',
  'PLN',
  'RON',
  'SEK',
  'USD',
  'ZAR',
] as const;
